import { fetcher } from '@commenda/utils';
import type {
  ChatRoomMessageChannel,
  ChatRoomSubscriptionStatus,
} from '@prisma/client';

export async function setChatRoomSubscriber(
  chatRoomId: string,
  userId: string,
  status: ChatRoomSubscriptionStatus,
  channel: ChatRoomMessageChannel
) {
  const res = await fetcher(`chatRoom/${chatRoomId}/subscribers/${userId}`, {
    method: 'PUT',
    body: { status, channel },
  });

  if (!res.ok) throw new Error('Failed to update chat room subscriber');

  return res.json();
}
